module.exports = __webpack_public_path__ + "img/icos2.0f9bfb0d.png";